import styles from "./Role.module.scss";
const Role = ({ key, item }) => {
  return (
    <div key={key} className={styles["account-table-role-list"]}>
      {item.type == 1 ? (
        <div className={styles["green"]}>
          <p className={styles["type"]}>{item.name}</p>
          <p>{item.scope_name}</p>
        </div>
      ) : item.type == 2 ? (
        <div className={styles["purple"]}>
          <p className={styles["type"]}>{item.name}</p>
          <p>{item.scope_name}</p>
        </div>
      ) : (
        <div className={styles["gold"]}>
          <p>Personal profile</p>
        </div>
      )}
    </div>
  );
};

export default Role;
